export const en: Record<string, string> = {
  "company.profile": "Company profile sections",
  "company.dashboard.back": "Back to Dashboard",
  "company.dashboard.verifiedOrg": "Verified Organization",
  "company.dashboard.unverified": "Unverified",
  "company.dashboard.publicPage": "Public page",
  "company.dashboard.editProfile": "Edit profile",
  "company.dashboard.licenses": "Licenses & verification",
  "company.dashboard.completeness": "Business setup",
  "company.dashboard.optionalEnrichment": "Branding, classifications and offerings are optional. Verification is reviewed separately.",
  "company.dashboard.editOptional": "Edit business profile",
  "company.dashboard.sections": "sections",
  "company.dashboard.stillMissing": "Still missing",
  "company.dashboard.completeProfile": "Complete setup",
  "company.dashboard.profileComplete": "Your business setup is complete.",
  "company.dashboard.verification": "Verification",
  "company.dashboard.verified": "Verified",
  "company.dashboard.inReview": "In review",
  "company.dashboard.rejected": "Rejected",
  "company.dashboard.badgeActive": "Badge active.",
  "company.dashboard.registrationApproved": "Approved registration on file — badge also needs an active operating status.",
  "company.dashboard.registrationNeeded": "Add a registration and get it approved to earn the Verified badge.",
  "company.dashboard.organization": "Organization",
  "company.dashboard.type": "Type",
  "company.dashboard.status": "Status",
  "company.dashboard.onPlatform": "On KontrataPH",
  "company.dashboard.since": "Since",
  "company.dashboard.getSetUp": "Get set up",
  "company.dashboard.loading": "Loading dashboard…",
  "company.dashboard.notMember": "You are not allowed to view this business.",
  "company.settings.title": "Business settings",
  "company.settings.ownerOnly": "Only the business owner manages this business.",
  "company.dashboard.notFound": "Organization not found.",
  "company.dashboard.addLogo": "Add logo",
  "company.dashboard.changeLogo": "Change",
  "company.dashboard.uploadFailed": "Upload failed.",
  "company.a.details": "Company details",
  "company.a.name": "Company name",
  "company.a.location": "Location",
  "company.a.industry": "Primary industry",
  "company.a.roles": "Business roles",
  "company.a.approved": "Approved",
  "company.a.readiness": "Business readiness",
  "company.a.ready": "Everything is ready",
  "company.a.submitted": "Registration submitted",
  "company.a.finish": "Complete your business setup",
  "company.a.complete": "Complete",
  "company.a.myCompany": "My Company",
  "company.a.owner": "Owner",
  "company.a.businessProfile": "Business profile",
  "company.a.navigation": "Company navigation",
  "company.a.dashboard": "Dashboard",
  "company.a.personal": "Personal dashboard",
  "company.a.managing": "Managing as",
  "company.a.actions": "Company actions",
  "company.a.changeCover": "Change cover",
  "company.a.addCover": "Add cover",
  "company.a.sections": "Company sections",
  "company.a.settingsCopy": "Manage the details and preferences of your company.",
  "company.a.openSettings": "Open settings",
  "company.a.imageFormat": "Choose a JPEG, PNG or WebP image up to 5 MB.",
  "company.a.readyCopy": "Your business registration is approved. Your company is visible to the marketplace.",
  "company.a.pendingCopy": "Your registration is under Admin review. Marketplace activity unlocks after approval.",
  "company.dashboard.step.profile": "Complete business setup",
  "company.dashboard.step.registration": "Add a registration or license",
  "company.dashboard.step.approval": "Get a verified registration approved",
  "company.dashboard.step.badge": "Earn the Verified Organization badge",
  "company.completeness.Organization name": "Organization name",
  "company.completeness.Tagline": "Tagline",
  "company.completeness.Location": "Location",
  "company.completeness.What this profile represents": "What this profile represents",
  "company.completeness.Organization type": "Organization type",
  "company.completeness.Subtype": "Subtype",
  "company.completeness.Ownership classification": "Ownership classification",
  "company.completeness.Operating status": "Operating status",
  "company.completeness.Business roles": "Business roles",
  "company.completeness.Primary industry": "Primary industry",
  "company.completeness.Service coverage": "Service coverage",
  "company.completeness.Products & services": "Products & services",
  "company.completeness.Profile setup": "Profile setup",
};

export const tl: Record<string, string> = {
  "company.profile": "Profile ng Kompanya",
  "company.dashboard.back": "Bumalik sa Dashboard",
  "company.dashboard.verifiedOrg": "Beripikadong Organisasyon",
  "company.dashboard.unverified": "Hindi Beripikado",
  "company.dashboard.publicPage": "Pampublikong pahina",
  "company.dashboard.editProfile": "I-edit ang profile",
  "company.dashboard.licenses": "Mga Lisensya at Beripikasyon",
  "company.dashboard.completeness": "Pag-set up ng negosyo",
  "company.dashboard.optionalEnrichment": "Opsyonal ang branding, mga klasipikasyon at mga alok. Hiwalay na sinusuri ang beripikasyon.",
  "company.dashboard.editOptional": "I-edit ang profile ng negosyo",
  "company.dashboard.sections": "seksyon",
  "company.dashboard.stillMissing": "Kulang pa",
  "company.dashboard.completeProfile": "Kumpletuhin ang pag-set up",
  "company.dashboard.profileComplete": "Kumpleto na ang pag-set up ng negosyo.",
  "company.dashboard.verification": "Beripikasyon",
  "company.dashboard.verified": "Beripikado",
  "company.dashboard.inReview": "Sinusuri",
  "company.dashboard.rejected": "Tinanggihan",
  "company.dashboard.badgeActive": "Aktibo ang badge.",
  "company.dashboard.registrationApproved": "May aprubadong rehistro — kailangan ding aktibo ang operating status para sa badge.",
  "company.dashboard.registrationNeeded": "Magdagdag ng rehistro at ipaapruba ito para makuha ang Verified badge.",
  "company.dashboard.organization": "Organisasyon",
  "company.dashboard.type": "Uri",
  "company.dashboard.status": "Katayuan",
  "company.dashboard.onPlatform": "Nasa KontrataPH",
  "company.dashboard.since": "Mula noong",
  "company.dashboard.getSetUp": "I-set up ang profile",
  "company.dashboard.loading": "Nilo-load ang dashboard…",
  "company.dashboard.notMember": "Wala kang pahintulot na tingnan ang negosyong ito.",
  "company.settings.title": "Mga setting ng negosyo",
  "company.settings.ownerOnly": "Ang may-ari lamang ang namamahala sa negosyong ito.",
  "company.dashboard.notFound": "Hindi makita ang organisasyon.",
  "company.dashboard.addLogo": "Magdagdag ng logo",
  "company.dashboard.changeLogo": "Palitan",
  "company.dashboard.uploadFailed": "Hindi na-upload.",
  "company.a.details": "Mga detalye ng kompanya",
  "company.a.name": "Pangalan ng kompanya",
  "company.a.location": "Lokasyon",
  "company.a.industry": "Pangunahing industriya",
  "company.a.roles": "Mga tungkulin ng negosyo",
  "company.a.approved": "Aprubado",
  "company.a.readiness": "Kahandaan ng negosyo",
  "company.a.ready": "Handa na ang lahat",
  "company.a.submitted": "Naisumite na ang rehistro",
  "company.a.finish": "Kumpletuhin ang pag-set up ng negosyo",
  "company.a.complete": "Kumpleto",
  "company.a.myCompany": "Aking Kompanya",
  "company.a.owner": "May-ari",
  "company.a.businessProfile": "Profile ng negosyo",
  "company.a.navigation": "Nabigasyon ng kompanya",
  "company.a.dashboard": "Dashboard",
  "company.a.personal": "Personal na dashboard",
  "company.a.managing": "Pinamamahalaan bilang",
  "company.a.actions": "Mga aksyon sa kompanya",
  "company.a.changeCover": "Palitan ang cover",
  "company.a.addCover": "Magdagdag ng cover",
  "company.a.sections": "Mga seksyon ng kompanya",
  "company.a.settingsCopy": "Pamahalaan ang mga detalye at kagustuhan ng kompanya.",
  "company.a.openSettings": "Buksan ang mga setting",
  "company.a.imageFormat": "Pumili ng JPEG, PNG o WebP na larawan hanggang 5 MB.",
  "company.a.readyCopy": "Aprubado ang rehistro ng negosyo. Nakikita na ang kompanya sa marketplace.",
  "company.a.pendingCopy": "Sinusuri ng Admin ang rehistro. Magagamit ang mga aktibidad sa marketplace matapos maaprubahan.",
  "company.dashboard.step.profile": "Kumpletuhin ang pag-set up ng negosyo",
  "company.dashboard.step.registration": "Magdagdag ng rehistro o lisensya",
  "company.dashboard.step.approval": "Ipaapruba ang beripikadong rehistro",
  "company.dashboard.step.badge": "Kunin ang Verified Organization badge",
  "company.completeness.Organization name": "Pangalan ng organisasyon",
  "company.completeness.Tagline": "Tagline",
  "company.completeness.Location": "Lokasyon",
  "company.completeness.What this profile represents": "Kinakatawan ng profile na ito",
  "company.completeness.Organization type": "Uri ng organisasyon",
  "company.completeness.Subtype": "Subtype",
  "company.completeness.Ownership classification": "Klasipikasyon ng pagmamay-ari",
  "company.completeness.Operating status": "Katayuan sa pagpapatakbo",
  "company.completeness.Business roles": "Mga tungkulin sa negosyo",
  "company.completeness.Primary industry": "Pangunahing industriya",
  "company.completeness.Service coverage": "Saklaw ng serbisyo",
  "company.completeness.Products & services": "Mga produkto at serbisyo",
  "company.completeness.Profile setup": "Pag-set up ng profile",
};
